export enum ListBuilderLists {
    ALL = "all",
    INCLUDE_CHILDREN = "include-children",
    SELECTED = "selected",
}
